import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledCard = styled.div`
  background: var(--glass-bg);
  backdrop-filter: var(--glass-blur);
  -webkit-backdrop-filter: var(--glass-blur);
  border: 1px solid var(--glass-border);
  border-radius: ${props => props.radius || 'var(--radius-lg)'};
  box-shadow: var(--glass-shadow);
  padding: ${props => props.padding || '24px'};
  margin: ${props => props.margin || '0'};
  transition: var(--transition-smooth);
  height: ${props => props.height || 'auto'};
  width: ${props => props.width || 'auto'};
  position: relative;
  overflow: hidden;

  &:hover {
    transform: ${props => props.hoverable ? 'translateY(-4px)' : 'none'};
    box-shadow: ${props => props.hoverable ? '0 12px 40px 0 rgba(31, 38, 135, 0.12)' : 'var(--glass-shadow)'};
  }

  /* Subtle shimmer effect */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 50%;
    height: 100%;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.3) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    transform: skewX(-25deg);
    transition: 0.75s;
    pointer-events: none;
  }

  &:hover::before {
    left: 125%;
  }
`;

const GlassCard = ({ children, ...props }) => {
  return (
    <StyledCard {...props}>
      {children}
    </StyledCard>
  );
};

GlassCard.propTypes = {
  children: PropTypes.node,
  radius: PropTypes.string,
  padding: PropTypes.string,
  margin: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  hoverable: PropTypes.bool,
};

export default GlassCard;
